import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ConfirmModal } from '../ui/Modal';
import MoveToModal from './MoveToModal';

const SECONDARY =
  'px-3 py-1.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors modern-button-secondary text-sm';
const PRIMARY =
  'px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm';

/**
 * The dialogs behind the more-menu (useDocumentActions' `dialog`):
 * - duplicate: the page has sub-pages — copy them too, or only this page?
 * - move: Move to… (MoveToModal)
 * - delete: the page has sub-pages — the sidebar's delete confirmation.
 */
export default function DocumentActionModals({ actions, documentId, scope, title }) {
  const { t } = useTranslation();
  const { dialog, setDialog, runDuplicate, performDelete } = actions;
  if (!dialog) return null;
  const close = () => setDialog(null);

  if (dialog.kind === 'move') return <MoveToModal documentId={documentId} scope={scope} onClose={close} />;

  if (dialog.kind === 'delete') {
    return (
      <ConfirmModal
        isOpen
        onClose={close}
        onConfirm={() => performDelete(dialog.subtree)}
        title={t('docEditor.actions.deleteTitle')}
        message={t('docEditor.actions.deleteMessage', {
          title: title || t('docEditor.untitled'),
          count: dialog.subtree.length - 1,
        })}
        confirmText={t('common.delete')}
        cancelText={t('common.cancel')}
        type="danger"
      />
    );
  }

  return (
    <Modal isOpen onClose={close} title={t('docEditor.actions.duplicateTitle')}>
      <p className="text-sm text-gray-600 dark:text-zinc-300">{t('docEditor.actions.duplicateMessage')}</p>
      <div className="flex justify-end space-x-2 pt-4">
        <button type="button" className={SECONDARY} onClick={close}>
          {t('common.cancel')}
        </button>
        <button type="button" className={SECONDARY} onClick={() => runDuplicate(false)}>
          {t('docEditor.actions.duplicateOnly')}
        </button>
        <button type="button" className={PRIMARY} onClick={() => runDuplicate(true)} autoFocus>
          {t('docEditor.actions.duplicateWithSubpages')}
        </button>
      </div>
    </Modal>
  );
}
